<template>
  <div>

    <div class="d-flex flex-wrap align-items-center justify-content-between mb-3 px-2"
      v-if="$auth.setting && $auth.setting.is_vendor_listing == false">
      <Breadcrumb :crumbs="breadcrumbs" v-if="$auth.setting && $auth.setting.is_vendor_listing == false" />

      <div class="search-item d-md-block col-lg-5 col-md-6 col-12 text-start">
        <input v-if="restautantDetails.item_counts <= $auth.setting.item_counts" type="search" v-model="search"
          name="search" class="srch-itm form-control" :placeholder="$t('Search')" />
        <router-link v-else :to="{ name: 'restaurant-search', params: { restaurant_id: restaurantID } }"
          class="w-100 d-block">
          <button class="srch-itm form-control text-start">
            {{ $t("Search for items") }}
          </button>
        </router-link>
      </div>
    </div>
    <div class="menuitems-main">
      <div class="cat-menu-cls bg-none" :class="newCateClassAdd"
        v-if="is_menu_category && cateMenus && cateMenus.length > 0">
        <nav class="category-menu-item-main px-0 bg-none mt-2">
          <menu-category v-for="catmenu in cateMenus" :key="catmenu.id" :menu="catmenu"
            v-on:setCategoryMenuId="openMenuCategoryList" :pagename="pageName"></menu-category>
        </nav>
      </div>

      <div class="menuitems-main-wrapper d-lg-flex">
        <!-------nav bar start------->
        <div class="side-menu-main">
          <h6 class="side-menu-title d-none d-lg-block sub-heading-primary">MENU</h6>
          <ul id="menulist" role="tablist" aria-orientation="vertical">
            <li v-if="recommendedList && recommendedList.length > 0" class="mb-0">
              <button class="nav-link w-100 text-start rmvactv 80 side-menu-link active" id="menuitem0"
                data-bs-toggle="pill" data-bs-target="#item0" v-if="
                  $auth.setting &&
                  $auth.setting.recommended_menu_name &&
                  $auth.setting.recommended_menu_name.length > 0
                " type="button" role="tab" aria-controls="item0" aria-selected="false">
                {{ $t($auth.setting.recommended_menu_name) }}
              </button>
            </li>
            <li v-for="(menu, index) in filteredData" :key="menu.id" class="mb-0">
              <div v-if="
                isPickupDelivery == '1' &&
                $auth.setting &&
                $auth.setting.is_vendor_listing == false &&
                $auth.setting.store_selection == 0
              ">
                <button class="nav-link w-100 text-start rmvactv 80 side-menu-link" :class="{
                  active:
                    (recommendedList.length == 0 && menu.id == menu_catgory_id) ||
                    (recommendedList.length <= 0 &&
                      index == 0 &&
                      recommendedList.length == 0 &&
                      index == 0 &&
                      (menu.id == -1
                        ? index == menu.id
                        : '' ||
                        (index == 0 &&
                          menu.id != '' &&
                          menu.id != menu.restaurant_menu_id
                          ? menu.restaurant_menu_id
                          : ''))),
                }" :id="'menuitem' + menu.id" data-bs-toggle="pill" :data-bs-target="'#item' + menu.id" type="button"
                  role="tab" :aria-controls="'item' + menu.id" aria-selected="false" @click="activeMenuAll(menu.id)">
                  {{ menu.name }}
                </button>
              </div>

              <div v-else>
                <button class="nav-link w-100 text-start rmvactv 80 side-menu-link"
                  :class="{ active: recommendedList.length <= 0 && index == 0 }" :id="'menuitem' + menu.id"
                  data-bs-toggle="pill" :data-bs-target="'#item' + menu.id" type="button" role="tab"
                  :aria-controls="'item' + menu.id" aria-selected="false" @click="activeMenuAll(menu.id)">
                  {{ menu.name }} ({{ menu.item_counts }})
                </button>
              </div>
            </li>
            <li v-for="mn in 6" :key="mn" v-if="menus.length == 0 && is_menu_skel_loader">
              <skeleton-loader-vue type="string" width="100%" height="29px" class="rmvactv 88 side-menu-link" />
            </li>
          </ul>
        </div>

        <div class="main-content w-100 flex-grow-1 d-flex flex-column">
          <div v-if="is_menu_skel_loader" class="menulength" id="itemmenumain">
            <section>
              <div class="media-heading">
                <h4 class="mb-4">
                  <skeleton-loader-vue type="string" width="24%" height="20px" />
                </h4>
              </div>
              <div class="media-itms media-itms-theme2">
                <div class="item_detail noImgClass" right="true" v-for="prdt in 4" :key="prdt">
                  <div class="media">
                    <a href="javascript:void(0)" id="element" class="btn btn-default show-modal">
                      <div class="media-body">
                        <h5 class="mt-0 me-5 item-name">
                          <skeleton-loader-vue type="string" width="24%" height="20px" />
                        </h5>
                        <div class="prc-show">
                          <span class="mt-2 d-inline-block item-price">
                            <skeleton-loader-vue type="string" width="54px" height="24px" />
                          </span>
                        </div>
                        <p class="mb-0 mt-2 item-descr">
                          <skeleton-loader-vue type="string" width="100%" height="20px" />
                        </p>
                      </div>
                    </a>
                    <div class="img-btn">
                      <div class="item-img itemimg-squre m-0">
                        <skeleton-loader-vue width="120" height="120" class="img-cls" style="border-radius: 5px" />
                      </div>
                      <div class="pgnme-cls btn-top">
                        <div class="nw-itm-btn">
                          <div class="sold-de">
                            <div class="icus">
                              <button class="btn btn-sm">
                                <skeleton-loader-vue type="string" width="50px" height="24px" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <div v-if="menus && menus.length > 0 && menusdata.length == 0"
            class="menulength border-0 card p-lg-5 p-3 product-wrapper" id="itemmenumain">
            <div class="tab-content" id="v-pills-tabContent">
              <section v-if="recommendedList.length > 0" id="item0" class="tab-pane fade show active" role="tabpanel"
                aria-labelledby="menuitem0">
                <!-- v-if="!search || search.trim() === ''" -->
                <div class="media-heading">
                  <h4 class="mb-4">{{ $t($auth.setting.recommended_menu_name) }}</h4>
                </div>
                <div class="media-itms" :class="'media-itms-theme' +
                  (itemlayout == null || itemlayout == '' ? '1' : itemlayout)
                  ">
                  <Product v-for="item in recommendedList" :key="item.item_id + item.restaurant_id" :item="item"
                    :right="true" menuId="0" v-on:openProductDetailModal="openProductDeails"
                    :restaurantID="item.restaurant_id" :restaurant_on_off="restaurant_on_off" :class="item.item_id"
                    :pagename="pageName" :itemlayout="itemlayout == null || itemlayout == '' || itemlayout == '7' ? '1' : itemlayout
                      " :restautantDetails="restautantDetails"></Product>
                </div>
              </section>
              <template v-for="(menu, index) in filteredData">
                <!-- <section
                  :id="'item' + menu.id"
                  v-if="menu.item_counts != 0 && is_menu_skel_loader == false"
                  :ref="'item' + menu.id"
                  class="menu-section p-0 m-0"
                  role="tabpanel"
                  :aria-labelledby="'menuitem' + menu.id"
                  tabindex="0"
                >
                  <div class="media-heading my-2" v-if="!search || search.trim() === ''">
                    <h4 class="fw-bold">{{ menu.name }}</h4>
                  </div>
                  <div
                    class="media-itms"
                    :class="
                      'media-itms-theme' +
                      (itemlayout == null || itemlayout == '' ? '1' : itemlayout)
                    "
                  >
                    <Product
                      v-if="menu.length > 0"
                      v-for="item in menu"
                      :key="itemlayout + '-' + item.item_id"
                      :item="item"
                      :right="true"
                      :menuId="menu.restaurant_menu_id"
                      v-on:openProductDetailModal="openProductDeails"
                      :restaurantID="item.restaurant_id"
                      :restaurant_on_off="restaurant_on_off"
                      :class="item.item_id"
                      :pagename="pageName"
                      :itemlayout="
                        itemlayout == null || itemlayout == '' ? '1' : itemlayout
                      "
                      :restautantDetails="restautantDetails"
                    ></Product>
                  </div>
                </section> -->
                <section :id="'item' + menu.id" v-if="menu.item_counts != 0 && is_menu_skel_loader == false"
                  :ref="'item' + menu.id" :class="[
                    cateMenus && cateMenus.length > 0 ? 'menu-section p-0 m-0' : 'menu-section p-0 m-0',
                    { 'show active': (recommendedList.length == 0 && index == 0) || (menu.id == active_el) }
                  ]" role="tabpanel" :aria-labelledby="'menuitem' + menu.id" tabindex="0">
                  <!-- class first ternery condition (tab-pane fade) for single preview -->
                  <!-- v-if="!search || search.trim() === ''" -->
                  <div class="media-heading mb-2 mt-4">
                    <h4 class="fw-bold">{{ menu.name }} ({{ menu.item_counts }})</h4>
                  </div>
                  <div class="media-itms" :class="'media-itms-theme' +
                    (itemlayout == null || itemlayout == '' || itemlayout == '7' ? '1' : itemlayout)
                    ">
                    <Product v-if="menu.length > 0" v-for="item in menu" :key="itemlayout + '-' + item.item_id"
                      :item="item" :right="true" :menuId="menu.restaurant_menu_id"
                      v-on:openProductDetailModal="openProductDeails" :restaurantID="item.restaurant_id"
                      :restaurant_on_off="restaurant_on_off" :class="item.item_id" :pagename="pageName" :itemlayout="itemlayout == null || itemlayout == '' ? '1' : itemlayout
                        " :restautantDetails="restautantDetails"></Product>
                  </div>
                </section>
              </template>
            </div>

            <div v-if="Object.keys(filteredData).length === 0">
              <div class="no-txt-fnd">
                <img v-lazy="require('@/assets/images/no_search.png')" />
                <h6>{{ $t("No Item Found") }}</h6>
                <!-- <span>{{ $t("Please remove filters to see items") }}</span> -->
              </div>
            </div>
          </div>
          <div v-else-if="menusdata" class="menulength border-0 card p-lg-5 p-4 product-wrapper" id="itemmenumain 8">
            <div>
              <section class="p-0 m-0" :id="'item' + menusdata.id" v-if="menusdata.menu_item_detail != 0">
                <div class="media-heading">
                  <h4 class="fw-bold">{{ menusdata.name }}</h4>
                </div>
                <div class="media-itms" :class="'media-itms-theme' +
                  (itemlayout == null || itemlayout == '' || itemlayout == '7' ? '1' : itemlayout)
                  ">
                  <Product v-for="item in filteredItemData" :key="itemlayout + '-' + item.id" :item="item" :right="true"
                    :menuId="menusdata.id" v-on:openProductDetailModal="openProductDeails"
                    :restaurantID="item.restaurant_id" :restaurant_on_off="restaurant_on_off" :class="item.id"
                    :pagename="pageName" :itemlayout="itemlayout == null || itemlayout == '' ? '1' : itemlayout
                      " :restautantDetails="restautantDetails"></Product>
                </div>
              </section>
            </div>
            <div v-if="
              Object.keys(filteredItemData).length === 0 && is_menu_skel_loader == false
            ">
              <div class="no-txt-fnd">
                <img v-lazy="require('@/assets/images/no_search.png')" />
                <h6>{{ $t("No Item Found") }}</h6>
              </div>
            </div>
          </div>

          <div v-else class="home-res-not-found mt-4">
            <div class="no-txt-fnd" v-if="!is_menu_skel_loader">
              <img v-lazy="require('@/assets/images/no_search.png')" />
              <h6>{{ $t("No Item Found") }}</h6>
              <span>{{ $t("Please remove filters to see items") }}</span>
            </div>
          </div>
        </div>
      </div>
      <ProductDetails ref="childComponent" :restaurantID="restaurantID" :restaurant_on_off="restaurant_on_off"
        :itemDetails="itemDetails" :pagename="pageName"></ProductDetails>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Product from "@/components/Product.vue";
import ProductDetails from "@/components/ProductDetails.vue";
import MenuCategory from "@/components/MenuCategory.vue";
import VueSkeletonLoader from "skeleton-loader-vue";
import Breadcrumb from "../components/Breadcums.vue";
import Subscription from "../views/Subscription.vue";

export default {
  components: {
    Product,
    ProductDetails,
    MenuCategory,
    Subscription,
    Breadcrumb,
    "skeleton-loader-vue": VueSkeletonLoader,
  },
  props: ["restaurant_on_off", "restautantDetails", "search"],
  data() {
    return {
      menu_catgory_id: localStorage.getItem("setMenuCategoryId"),
      itemDetails: null,
      menus: [],
      restaurantID: "",
      selectedSection: 0,
      vendorID: "",
      date: "",
      starttime: "",
      productDetails: { type: Object },
      active_el: 0,
      loading: true,
      limit: 10,
      totalItems: 0,
      scrollPosition: 0,
      total_record: 20,
      skiped: 0,
      pageName: "itemslist",
      routerItemId: 0,
      routerItemIdStatus: true,
      is_menu_category: false,
      cateMenus: [],
      menuCategryId: 0,
      is_menu_skel_loader: true,
      menusdata: [],
      isSearchHide: true,
      itemlayout: "1",
      newCateClassAdd: "",
      itemTypeFilterKey: "",
      itemType: [],
      typeUniqNumbers: [],
      selectType: [],
      listItemVeg: [],
      restTags: [],
      recommendedList: [],
      emptyMenuId: "",
      menu_item_count: 0,
      selectedMenuId: "",
      menuCatName: "",
      itemDetailsId: 0,
      throttleTimeout: null,
      isFetching: false,
      isScrollingProgrammatically: false,
    };
  },

  computed: {
    ...mapGetters("order", ["isPickupDelivery"]),

    breadcrumbs() {
      if (this.menuCatName) {
        return [
          { text: "Home", link: "/" },
          { text: this.restautantDetails.name, link: "/" },
          { text: this.menuCatName || "Loading...", link: "" },
        ];
      } else {
        return [
          { text: "Home", link: "/" },
          { text: this.restautantDetails.name || "Loading...", link: "/" },
        ];
      }
    },

    filteredData() {
      this.recommendedList = [];
      return Object.keys(this.menus).reduce((a, cKey) => {
        const data = this.filterValue(this.menus[cKey]);
        if (data != undefined && data.length) {
          let menuName = this.menus[cKey].name;
          let nerecomm = data.find((itm) => itm.is_featured == "1");
          if (nerecomm != undefined) {
            this.recommendedList.push(nerecomm);
          }
          a[cKey] = data;
          a[cKey].name = menuName;
          a[cKey].item_counts = this.menus[cKey].item_counts;
          a[cKey].id = this.menus[cKey].id;
          a[cKey].restaurant_menu_id = this.menus[cKey].restaurant_menu_id;
        } else {
          // Only include menu categories with no filtered items if there's no active search
          if (!this.search || this.search.trim() === '') {
            a[cKey] = this.menus[cKey];
          }
        }

        if (this.selectType.length == 0) {
          this.filterItemType();
        }

        return a;
      }, {});
    },

    filteredItemData() {
      return Object.keys(this.menusdata).reduce((a, cKey) => {
        this.recommendedList = [];
        const data = this.filterValue(this.menusdata);
        if (data != undefined && data.length) {
          let menuName = this.menusdata.name;
          a = data;
          a.name = menuName;
          a.item_counts = 0;
          a.id = this.menusdata.id;
          data.forEach((item) => {
            if (item.item_type == "0" || item.item_type == "1" || item.item_type == "2") {
              this.itemType.push(item.item_type);
            }
          });
        }
        if (this.selectType.length == 0) {
          this.filterItemType();
        }
        return a;
      }, {});
    },
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    let routerHasValue = this.$route.hash;
    if (routerHasValue) {
      this.routerItemId = routerHasValue.replace("#item", "");
    }
    this.vendorID = this.$auth.getVendorId();
    if (
      this.$route.params &&
      this.$route.params.restaurant_slug_id &&
      this.$route.params.restaurant_slug_id != ""
    ) {
      // let restId = this.$route.params.restaurant_id;
      // this.restaurantID = this.base64_decode(restId);      
      let restId = this.$route.params.restaurant_slug_id;
      this.restaurantID = restId.split('-rid').pop();
    } else {
      this.restaurantID = this.restautantDetails && this.restautantDetails.id;
    }

    this.itemlayout = this.restautantDetails && this.restautantDetails.item_layout;
    if (this.itemlayout == "") {
      this.itemlayout = 1;
    }

    if (
      this.restautantDetails &&
      this.$auth.setting &&
      this.restautantDetails.item_counts > this.$auth.setting.item_counts
    ) {
      this.isSearchHide = false;
      this.getCategoryWiseMenuList();
    } else {
      if (
        this.restautantDetails &&
        this.restautantDetails.item_counts <= this.$auth.setting.item_counts
      ) {
        this.isSearchHide = true;
        let is_exist_menu_category_available = localStorage.getItem(
          "is_exist_menu_category"
        );

        if (
          is_exist_menu_category_available == "true" ||
          is_exist_menu_category_available == true ||
          (this.restautantDetails && this.restautantDetails.menu_category_count > 0)
        ) {
          this.getCategoryWiseMenuList();
        } else {
          this.loadAllMenuItemsTogether();
        }
      } else {
        this.isSearchHide = true;
        this.getCategoryWiseMenuList();
      }
    }

    this.restTags = this.restautantDetails.restaurant_tags;
  },

  methods: {
    ...mapActions("product", ["getMenuProductList"]),
    ...mapActions("restaurant", [
      "getRestaurantMenuCategoryList",
      "getMenuWiseItem",
      "getCategoryWiseMenu",
    ]),

    filterItemType() {
      let uniqueType = [];
      if (this.itemType.length > 0) {
        $.each(this.itemType, function (i, el) {
          if ($.inArray(el, uniqueType) === -1) uniqueType.push(el);
        });
      }
      if (uniqueType.length == "1" && !uniqueType.includes("2")) {
        this.listItemVeg = uniqueType;
      }
      return uniqueType;
    },

    loadAllMenuItemsTogether() {
      this.loading = true;
      this.is_menu_skel_loader = true;

      this.getMenuProductList({
        params: {
          restaurant_id: this.restaurantID,
          skip: 0,
          menu_category_id: this.menuCategryId ? this.menuCategryId : 0,
        },
      })
        .then((response) => {
          if (response.status == true) {
            this.loading = false;
            this.menus = response.data;
            let itemtypeArray = [];
            this.menus.forEach((element) => {
              if (element.menu_item_detail && element.menu_item_detail.length > 0) {
                element.menu_item_detail.forEach((elm) => {
                  itemtypeArray.push(elm.item_type);
                });
              }
            });
            this.itemType = itemtypeArray;

            let findfirst = this.menus.find((el) => el.item_counts > 0);
            if (findfirst && this.recommendedList.length > 0) {
              this.active_el = findfirst.restaurant_menu_id;
            }
          }
        })
        .catch((error) => {
          this.menus = [];
          this.is_menu_skel_loader = false;
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
          this.is_menu_skel_loader = false;
        });
    },

    updateActiveSideMenu(itemId) {
      // Only update if we're not already on this item
      if (this.active_el !== itemId) {
        document.querySelectorAll(".side-menu-link").forEach((button) => {
          button.classList.remove("active");
        });

        const clickedButton = document.getElementById(`menuitem${itemId}`);
        if (clickedButton) {
          clickedButton.classList.add("active");
        }
      }
    },

    scrollToSection(itemId) {
      this.$nextTick(() => {
        const section = document.getElementById(`item${itemId}`);
        if (section) {
          // Temporarily disable scroll event listener
          window.removeEventListener("scroll", this.handleScroll);
          this.isScrollingProgrammatically = true;

          const headerOffset = 120; // Increased offset for better detection
          const elementPosition = section.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });

          // Re-enable scroll listener after scroll completes
          setTimeout(() => {
            window.addEventListener("scroll", this.handleScroll);
            this.active_el = itemId;
            this.updateActiveSideMenu(itemId);
            this.isScrollingProgrammatically = false;
          }, 800); // Match this duration with your scroll animation
        }
      });
    },

    updateActiveMenuOnScroll() {
      if (this.isScrollingProgrammatically) return;

      const menuSections = document.querySelectorAll(".menu-section, .tab-pane");
      const headerOffset = 120;
      let currentActiveId = null;
      let smallestDistance = Infinity;

      // Find the section closest to the top of the viewport
      menuSections.forEach((section) => {
        // Skip the recommended section (id="item0") if it exists
        if (section.id === "item0") return;

        const rect = section.getBoundingClientRect();
        const menuId = section.getAttribute("id").replace("item", "");
        const distance = Math.abs(rect.top - headerOffset);

        if (rect.top <= headerOffset + 100 && rect.bottom >= headerOffset) {
          if (distance < smallestDistance) {
            smallestDistance = distance;
            currentActiveId = menuId;
          }
        }
      });

      // Only update if we found a section and it's different from current
      if (currentActiveId && currentActiveId !== this.active_el) {
        this.active_el = currentActiveId;
        this.updateActiveSideMenu(currentActiveId);
      }
    },

    activeMenuAll(itemId) {
      // Prevent multiple clicks during transition
      if (this.active_el === itemId) return;

      // Check if we have category menus and they have values
      if (this.cateMenus && this.cateMenus.length > 0) {
        this.updateActiveSideMenu(itemId);
        this.scrollToSection(itemId);
        this.active_el = itemId;
        return;
      }

      // Original logic for when there are no categories
      if (this.restautantDetails.item_counts <= this.$auth.setting.item_counts) {
        this.updateActiveSideMenu(itemId);
        this.scrollToSection(itemId);
      } else {
        this.is_menu_skel_loader = true;
        this.menusdata = {};
        this.skiped = 0;
        this.scrollPosition = 0;
        this.total_record = 20;
        window.scrollTo(0, 0);
        this.getMenuWiseItemList(itemId);
      }

      this.active_el = itemId;
    },

    itemFilterClick(type, tag) {
      if (this.selectType.indexOf(type) === -1) {
        this.selectType.push(type);
      } else {
        let newArray = this.selectType.filter((e) => e !== type);
        this.selectType = newArray;
      }
    },

    filterValue(content) {
      let itemProduct = content.menu_item_detail;
      if (itemProduct) {
        if (itemProduct && Array.isArray(itemProduct) && itemProduct.length > 0) {
          const match = itemProduct.find((detail) => detail.id == this.itemDetailsId);
          if (match) {
            this.itemDetails = match;
          }
        }

        return itemProduct.filter((item) => {
          if (this.selectType.length > 0) {
            let newdata = this.selectType.findIndex((type) => type === item.item_type);
            let newTagsSearch = this.selectType.findIndex((type) =>
              item.item_tags.some((x) => x.name == type)
            );
            if (newdata != -1 || newTagsSearch != -1) {
              return item;
            }
          } else {
            let itemUpper = item.name.toLowerCase();
            let searchUpper = this.search.toLowerCase();
            return itemUpper.indexOf(searchUpper) > -1;
          }
        });
      }
    },

    openMenuCategoryList(id) {
      this.recommendedList = [];
      this.menus = [];
      this.menuCategryId = id;
      if (!this.menus || this.menus.length === 0) {
        this.categoryMenuProduct();
      }
      const selectedCategory = this.cateMenus.find((c) => c.id == id);
      if (selectedCategory) {
        this.menuCatName = selectedCategory.name;
      }
    },

    categoryMenuProduct() {
      if (this.menus && this.menus.length > 0) {
        this.loading = false;
        this.is_menu_skel_loader = false;
        return;
      }
      this.loading = true;
      this.is_menu_skel_loader = true;
      this.getMenuProductList({
        params: {
          restaurant_id: this.restaurantID,
          skip: 0,
          menu_category_id: this.menuCategryId,
        },
      })
        .then((response) => {
          if (response.status == true) {
            this.loading = false;
            this.menus = response.data;
            let itemtypeArray = [];
            this.menus.forEach((element) => {
              if (element.menu_item_detail && element.menu_item_detail.length > 0) {
                element.menu_item_detail.forEach((elm) => {
                  itemtypeArray.push(elm.item_type);
                });
              }
            });
            this.routerItemId = localStorage.getItem("menuCatID");
            this.itemType = itemtypeArray;
            let findfirst = this.menus.find((el) => el.item_counts > 0);
            if (findfirst && this.recommendedList.length > 0) {
              this.active_el = findfirst.restaurant_menu_id;
            }
          }
        })
        .catch((error) => {
          this.menus = [];
          if (this.routerItemId > 0) {
            setTimeout(() => this.activeMenu(this.routerItemId), 1200);
          }
          let element = document.getElementById("menucateID-" + this.menuCategryId);
          $(".menucate-cls").removeClass("active");
          if (element != null) {
            element.className += " active";
          }
          this.is_menu_skel_loader = false;
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
          this.is_menu_skel_loader = false;
        });
    },

    openProductDeails(value) {
      this.itemDetailsId = value.id;
      window.$("#item-popup").modal("show");
      window.$("#item-popup").on("shown.bs.modal", function () { });

      window.$("#item-popup").on("hidden.bs.modal", () => {
        if (this.$refs.childComponent) {
          this.$refs.childComponent.productDetail = null;
          this.$refs.childComponent.selectedCustomisation = {
            customize_type: {},
          };
        }
      });
      this.$refs.childComponent.openProductModel(value.id);
    },

    async activeMenu(itemId) {
      let id = "item" + itemId;
      this.selectedSection = id;
      if (
        this.restautantDetails &&
        this.$auth.setting &&
        this.restautantDetails.item_counts > this.$auth.setting.item_counts &&
        this.restautantDetails.menu_category_count == 0
      ) {
        this.is_menu_skel_loader = true;
        this.menusdata = {};
        this.skiped = 0;
        this.scrollPosition = 0;
        this.total_record = 20;
        window.scrollTo(0, 0);
        await this.getMenuWiseItemList(itemId);
      }
    },

    getCategoryWiseMenuList() {
      if (this.cateMenus && this.cateMenus.length > 0) {
        return;
      }
      if (
        this.$auth.setting &&
        this.$auth.setting.is_vendor_listing == false &&
        this.$auth.setting.store_selection == 0 &&
        this.restautantDetails.menu_category_count == 0
      ) {
        this.is_menu_category = false;
        this.loading = true;
        this.getCategoryWiseMenu({
          restaurant_id: this.restaurantID,
        }).then((data) => {
          if (data.code == 200 || data.status == true) {
            this.loading = false;
            this.is_menu_skel_loader = false;
            this.menus = data.data;
            let findfirst = this.menus.find((el) => el.item_counts > 0);

            if (this.restautantDetails.item_counts > this.$auth.setting.item_counts) {
              if (localStorage.getItem("setMenuCategoryId")) {
                this.getMenuWiseItemList(localStorage.getItem("setMenuCategoryId"));
              } else {
                if (findfirst) {
                  this.active_el = findfirst.restaurant_menu_id;
                  this.getMenuWiseItemList(findfirst.id);
                }
              }
            } else {
              if (findfirst) {
                this.active_el = findfirst.id;
              }
            }
            localStorage.setItem("menuCatID", "");
          } else {
            this.is_menu_skel_loader = false;
            this.loading = false;
          }
        });
      } else if (
        this.restautantDetails &&
        this.restautantDetails.menu_category_count == 0
      ) {
        this.is_menu_category = false;
        this.loading = true;
        this.getCategoryWiseMenu({
          restaurant_id: this.restaurantID,
        })
          .then((response) => {
            if (response.status == true) {
              this.loading = false;
              this.is_menu_skel_loader = false;
              this.menus = response.data;
              let findfirst = this.menus.find((el) => el.item_counts > 0);

              if (this.restautantDetails.item_counts > this.$auth.setting.item_counts) {
                if (findfirst) {
                  this.active_el = findfirst.id;
                  this.getMenuWiseItemList(findfirst.id);
                }
              } else {
                if (findfirst) {
                  this.active_el = findfirst.id;
                }
              }
            } else {
              this.is_menu_skel_loader = false;
              this.loading = false;
            }
          })
          .finally(() => {
            this.loading = false;
            this.is_menu_skel_loader = false;
          });
      } else if (
        this.restautantDetails &&
        this.restautantDetails.menu_category_count > 0
      ) {
        this.is_menu_category = true;
        this.getRestaurantMenuCategoryList({
          restaurant_id: this.restaurantID,
        }).then((response) => {
          if (response.status == true) {
            this.loading = false;
            this.cateMenus = response.data;
            this.newCateClassAdd = "cateNewClass";
            if (
              localStorage.getItem("menuCatID") == null ||
              localStorage.getItem("menuCatID") == ""
            ) {
              if (this.cateMenus && this.cateMenus[0]) {
                this.menuCategryId = this.cateMenus[0].id;
                this.categoryMenuProduct();
              }
            } else {
              this.openMenuCategoryList(localStorage.getItem("setMenuCategoryId"));
            }
          } else {
            this.is_menu_skel_loader = false;
            this.loading = false;
          }
        });
      }
    },

    getMenuWiseItemList(itemId, append = false) {
      this.selectedMenuId = itemId;
      if (this.isFetching) return; // Prevent multiple calls
      this.isFetching = true;
      this.is_menu_category = false;
      this.loading = false; // Show loader only on first fetch
      this.is_menu_skel_loader = true;
      this.getMenuWiseItem({
        params: {
          restaurant_id: this.restaurantID,
          skip: this.skiped,
          total_record: this.total_record,
          menu_id: itemId,
        },
      })
        .then((response) => {
          if (response.status == true) {
            if (append) {
              this.menusdata.menu_item_detail = [
                ...this.menusdata.menu_item_detail,
                ...response.data[0].menu_item_detail,
              ];
            } else {
              this.menusdata = response.data[0];
            }
            const selectedMenu = this.menus.find((item) => item.id == itemId);
            if (selectedMenu) {
              this.totalItems = selectedMenu.item_counts;
            }
            this.skiped += this.total_record;
          }

          this.loading = false;
          this.is_menu_skel_loader = false;
          this.isFetching = false;
        })
        .catch(() => {
          this.loading = false;
          this.is_menu_skel_loader = false;
          this.isFetching = false;
        });
    },

    handleScroll() {
      // krushil works
      if (this.throttleTimeout) return;
      this.throttleTimeout = setTimeout(() => {
        this.scrollPosition = window.scrollY;
        if (this.restautantDetails.item_counts <= this.$auth.setting.item_counts) {
          this.updateActiveMenuOnScroll();
        }
        if (this.restautantDetails.item_counts > this.$auth.setting.item_counts) {
          const bottom =
            window.innerHeight + this.scrollPosition >=
            document.documentElement.scrollHeight - 100;
          const hasMoreItems =
            this.menusdata &&
            this.menusdata.menu_item_detail &&
            this.menusdata.menu_item_detail.length < this.totalItems;
          if (bottom && !this.isFetching && hasMoreItems) {
            this.getMenuWiseItemList(this.selectedMenuId, true);

          }
        }

        this.throttleTimeout = null;
      }, 200);
    },

    //sandeep works
    // handleScroll() {
    //   this.scrollPosition = window.scrollY;
    //   const bottom = window.innerHeight + this.scrollPosition >= document.documentElement.scrollHeight - 100;
    //   const hasMoreItems = this.menusdata && this.menusdata.menu_item_detail && this.menusdata.menu_item_detail.length < this.totalItems;
    //   if (bottom && !this.isFetching && hasMoreItems) {
    //     this.getMenuWiseItemList(this.selectedMenuId, true);
    //   }
    // },


    // async fetchMoreItems() {
    //   this.isFetching = true;
    //   await this.getMenuWiseItemList(this.selectedMenuId, true);
    //   this.isFetching = false;
    // },
  },
};
</script>

<style>
.menuSkel {
  border-radius: 30px !important;
}

.skel-loader {
  display: flex;
}

.sticcitem img {
  height: 30px;
  object-fit: contain;
}

.menu_tag {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
</style>